import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeAdministracaoConsultaBem: [],
    removeDescricaoModeloConsultaBem: [],
    removeAnoModeloConsultaBem: [],
    removePlacaConsultaBem: [],
    removeCodigoSituacaoLegalConsultaBem: [],
    removeIdentificacaoConsultaBem: [],
    setMostraAplicarFiltroConsultaBem: [],
    limpaFiltroConsultaBem: [],
    aplicarFiltroConsultaBem: ['filtro'],
})

const INITIAL_STATE = {
    administracao: [],
    descricaoModelo: '',
    anoModelo: '',
    placa: '',
    codigoSituacaoLegal: [],
    identificacao: '',
    mostraAplicarFiltro: false,
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracao.splice(state.administracao.indexOf(action.administracao), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.administracao = Array.from(state.administracao)
    return { ...state, mostraAplicarFiltro: true }
}

const removeCodigoSituacaoLegal = (state = INITIAL_STATE, action) => {
    state.codigoSituacaoLegal.splice(state.codigoSituacaoLegal.indexOf(action.codigoSituacaoLegal), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.codigoSituacaoLegal = Array.from(state.codigoSituacaoLegal)
    return { ...state, mostraAplicarFiltro: true }
}

const removeDescricaoModelo = (state = INITIAL_STATE, action) => {
    return { ...state, descricaoModelo: '', mostraAplicarFiltro: true }
}

const removeAnoModelo = (state = INITIAL_STATE, action) => {
    return { ...state, anoModelo: '', mostraAplicarFiltro: true }
}

const removePlaca = (state = INITIAL_STATE, action) => {
    return { ...state, placa: '', mostraAplicarFiltro: true }
}

const removeIdentificacacao = (state = INITIAL_STATE, action) => {
    return { ...state, identificacao: '', mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_BEM]: removeAdministracao,
    [Types.REMOVE_DESCRICAO_MODELO_CONSULTA_BEM]: removeDescricaoModelo,
    [Types.REMOVE_ANO_MODELO_CONSULTA_BEM]: removeAnoModelo,
    [Types.REMOVE_PLACA_CONSULTA_BEM]: removePlaca,
    [Types.REMOVE_CODIGO_SITUACAO_LEGAL_CONSULTA_BEM]: removeCodigoSituacaoLegal,
    [Types.REMOVE_IDENTIFICACAO_CONSULTA_BEM]: removeIdentificacacao,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_BEM]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_CONSULTA_BEM]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_BEM]: aplicarFiltro,
})
